import React, { useState } from 'react';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import useCurrencySelectStyles from './styles';

const CurrencySelect = ({ label, currencies, selectedCurrency, onCurrencyChange, formik }) => {
  const classes = useCurrencySelectStyles();

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredCurrencies = currencies.filter((currency) =>
    currency.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return <div className={classes.root}>
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id="demo-simple-select-filled-label">
        {label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={selectedCurrency}
        onChange={onCurrencyChange}
        sx={{
          borderRadius: "50px",
          backgroundColor: "#fff",
          boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {filteredCurrencies && filteredCurrencies.map((currency) =>
          <MenuItem key={currency.code} value={currency.code}>  {currency.code}</MenuItem>
        )}
      </Select>
    </FormControl>
  </div>;
};

CurrencySelect.propTypes = {};

export default CurrencySelect;
